/**
 * Copyright 2016 xdot GmbH
 *
 * Author: Marius Runde
 * Date: 19.07.2016
 *
 */
'use strict';
import L from 'external/leaflet';
import { AppContext, getLocalConfigStore } from 'plugin/liferay-widgets-react-web';
import datefns from 'external/datefns';

const LocalConfigStore = getLocalConfigStore(AppContext);

export default class PrintPlugin {

    constructor(props) {
        this.init = this.init.bind(this);
        this.onPrint = this.onPrint.bind(this);
        this.ACTIVE_UUIDS_KEY = '';
    }

    withCtx(s) {
        return (this.context && this.context.contextId ? this.context.contextId : 'DEFAULT_') + s;
    }

    _getLocalStorageKeyWithMapConfig(key) {
        if (this.context && this.context.contextId) {
            const mapConf = this.context;
            key += '_MAP_CONFIG_' + mapConf.contextId;
        }
        return key;
    }

    init(map, o) {
        this.ACTIVE_UUIDS_KEY = this.withCtx('_ACTIVE_UUIDS');
        this.map = map;
        this.printControlTemplate = L.Control.extend({
            options: {
                position: 'topleft'
            },

            onAdd: (map) => {
                this.container = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom hidden-xs hidden-sm');
                this.icon = L.DomUtil.create('span', 'fa fa-print', this.container);

                this.container.setAttribute('title', 'Karte drucken');
                this.container.setAttribute('role', 'button');

                L.DomEvent.on(this.container, 'click', this.onPrint, this);
                return this.container;

            }
        });
        this.printControl = new this.printControlTemplate();
        map.addControl(this.printControl);
    }

    update(map, o) {
        console.log('ExampleMapPlugin update()', map, o);
    }

    getLayerNames(layer, activeUuids, root) {
        let layerNames = '';
        let childNames = '';

        if (layer.children) {
            layer.children.forEach(child => {
                childNames += this.getLayerNames(child, activeUuids);
            });
        }
        if (childNames !== '') {
            layerNames += `<li><span class="${root ? 'bolder-heading' : 'bold-heading'}">${layer.title}</span><ul>${childNames}</ul></li>`;
        } else {
            if (activeUuids[layer.uuid]) {
                layerNames += `<li>${layer.title}</li>`;
            }
        }

        return layerNames;
    }

    onPrint(e) {
        L.DomEvent.stopPropagation(e);
        L.DomEvent.preventDefault(e);
        const mapContainer = this.map.getContainer();
        const isFullscreen = mapContainer.classList.contains('leaflet-pseudo-fullscreen');
        const originalWidth = mapContainer.style.width;
        const originalHeight = mapContainer.style.height;
        const originalBounds = this.map.getBounds();

        if (isFullscreen) {
            mapContainer.classList.remove('leaflet-pseudo-fullscreen');
        }
        mapContainer.style.width = 1240 + 'px';
        mapContainer.style.height = 1240 + 'px';
        this.map.fitBounds(originalBounds, { animate: false });
        this.map.invalidateSize(false);

        const prtContent = this.map._container.parentNode.cloneNode(true);
        prtContent.style.width = this.map._container.clientWidth + 'px';
        prtContent.style.height = this.map._container.clientHeight + 'px';
        const tiles = prtContent.getElementsByClassName('leaflet-tile');
        for (let tile of tiles) {
            tile.classList.add('leaflet-tile-loaded');
        }

        //reset original
        mapContainer.style.width = originalWidth;
        mapContainer.style.height = originalHeight;
        if (isFullscreen) {
            mapContainer.classList.add('leaflet-pseudo-fullscreen');
        }
        this.map.invalidateSize(false);
        this.map.fitBounds(originalBounds, { animate: false });

        const config = LocalConfigStore.getLocalConfig(this._getLocalStorageKeyWithMapConfig(this.ACTIVE_UUIDS_KEY));
        const activeUuids = config && config.properties;
        const layerDescriptions = this.map.options.layerDescriptions;
        const hasLayers = layerDescriptions && layerDescriptions.length > 0;
        let activeLayerNames = '';
        if (activeUuids && hasLayers) {
            layerDescriptions.forEach(layerDescription => {
                activeLayerNames += this.getLayerNames(layerDescription, activeUuids, true);
            });
        }

        let controlContainer = prtContent.getElementsByClassName('leaflet-control-container')[0];
        const controls = Array.from(controlContainer.children).filter(node => node && !(node.classList.contains('leaflet-bottom') && node.classList.contains('leaflet-right')));
        for (const control of controls) {
            control.style = 'display: none;';
        }

        // canvas inside the cloned node are empty -> use original
        const original_cnavas = this.map._container.getElementsByTagName('canvas');
        Array.from(prtContent.getElementsByTagName('canvas')).forEach((canvasCopy, idx) => {
            const canvas = original_cnavas.item(idx);
            const img = new Image();
            img.src = canvas.toDataURL('image/png');
            img.style.cssText = canvas.style.cssText;
            img.classList = canvas.classList;
            canvasCopy.parentNode.replaceChild(img, canvasCopy);
        });

        const head = document.head.cloneNode(true);
        Array.from(head.getElementsByTagName('script')).forEach(tag => {
            tag.parentNode.removeChild(tag);
        });

        const html = `
            ${head.innerHTML}
            <body style="-webkit-print-color-adjust: exact;color-adjust: exact;">
                <h3>FLIWAS-Karte</h3>
                <div class="py-3">
                    ${hasLayers ? '<h3>Aktive Themen</h3>' : ''}
                    <ul style="list-style: none; padding: 0">
                        ${activeLayerNames}
                    </ul>
                </div>
                ${prtContent.innerHTML}
                <footer class="p-3">
                     ${datefns.format(new Date(), 'dd.MM.yy HH:mm')} Uhr, ${window.themeDisplay.getUserName()}
                </footer>
                <script>
                    window.onload = function() {
                        setTimeout(() => {    
                            window.print();
                        }, 100);
                    };
                </script>
            </body>
        `;
        const WinPrint = window.open('', 'FLIWAS-Karte');
        WinPrint.document.write(html);
        WinPrint.document.close();
        WinPrint.focus();

        WinPrint.onafterprint = function(event) {
            WinPrint.close();
        };
    }

}



// WEBPACK FOOTER //
// ./js/plugins/PrintPlugin.js